// extracted by mini-css-extract-plugin
export default {"editPhoto":"FileInput_editPhoto__dqhVg","inputFile":"FileInput_inputFile__AHfDN","menu":"FileInput_menu__PUMAy","remove":"FileInput_remove__1F8on"};